import { useState, useEffect } from 'react';

/**
 * Hook that tracks the scroll position of the window
 * @returns The current scroll position in pixels from the top
 */
export const useScrollPosition = (): number => {
  const [scrollPosition, setScrollPosition] = useState<number>(0);

  useEffect(() => {
    const updatePosition = () => {
      setScrollPosition(window.scrollY);
    };
    
    // Set the initial position
    updatePosition();
    
    // Add event listener
    window.addEventListener('scroll', updatePosition, { passive: true });
    
    // Clean up
    return () => window.removeEventListener('scroll', updatePosition);
  }, []);

  return scrollPosition;
};

export default useScrollPosition;